/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        margin: 40px 0;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 15,
        css: css`
            > div {
                margin-top: 0;
            }

            &.list-view {
                > div {
                    width: 100%;
                    margin: 0;

                    > div {
                        .productTileWrapper {
                            border-bottom: 0;
                            border-radius: 0;
                        }

                        &:first-child {
                            .productTileWrapper {
                                border-radius: 6px 6px 0 0;
                            }
                        }

                        &:last-child {
                            .productTileWrapper {
                                border-bottom: 1px solid ${getColor("common.ui12")};
                                border-radius: 0 0 6px 6px;
                            }
                        }
                    }
                }
            }
        `,
    },
};

listStyles.cardContainerMultiColumnStyles = {
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(3) {
                padding-top: 0;
            }
        `,
    },
    cardDivider: {
        css: css`
            height: 100%;
            width: 100%;
            overflow: hidden;
            display: flex;
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
};
